import React, { useState } from "react";
import { Plus } from "lucide-react";
import { FAQS } from "../mock";

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="faq">
      <div className="container">
        <div style={{ textAlign: "center", maxWidth: 700, margin: "0 auto 40px" }}>
          <span className="section-label center">Common Questions</span>
          <h2 className="section-title">Frequently Asked<br/><em>Questions</em></h2>
        </div>
        <div className="faq-grid">
          {FAQS.map((f, i) => (
            <div className={`faq-item ${open === i ? "open" : ""}`} key={i}>
              <div className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                <span>{f.q}</span>
                <div className="faq-icon"><Plus size={14} /></div>
              </div>
              <div className="faq-a"><div style={{ paddingTop: 4 }}>{f.a}</div></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
